import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Calendar, Euro, ArrowRight } from 'lucide-react';

const positionColors = {
  GK: 'position-gk',
  DEF: 'position-def',
  MID: 'position-mid',
  FWD: 'position-fwd',
};

const positionLabels = {
  GK: 'POR',
  DEF: 'DEF',
  MID: 'MED',
  FWD: 'DEL',
};

export const PlayerCard = ({ player }) => {
  const avatarUrl = player.photo_url || `https://api.dicebear.com/7.x/avataaars/svg?seed=${player.name}`;
  
  return (
    <Link 
      to={`/players/${player.id}`} 
      className="player-card block"
      data-testid={`player-card-${player.id}`}
    >
      {/* Image section */}
      <div className="relative aspect-[4/3] bg-slate-100 overflow-hidden">
        <img
          src={avatarUrl}
          alt={player.name}
          className="w-full h-full object-cover grayscale group-hover:grayscale-0 transition-all duration-500"
          onError={(e) => {
            e.target.src = `https://api.dicebear.com/7.x/avataaars/svg?seed=${player.name}`;
          }}
        />
        {/* Overlay gradient */}
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" />
        
        {/* Position badge */}
        <div className={`position-badge absolute top-3 left-3 ${positionColors[player.position]}`}>
          {positionLabels[player.position] || player.position}
        </div>

        {/* Availability badge */}
        <div className="absolute top-3 right-3">
          {player.availability === 'transfer' && (
            <span className="badge-available">Transferencia</span>
          )}
          {player.availability === 'loan' && (
            <span className="badge-loan">Préstamo</span>
          )}
          {player.availability === 'both' && (
            <span className="badge-available">Disponible</span>
          )}
        </div>

        {/* Name overlay */}
        <div className="absolute bottom-0 left-0 right-0 p-4">
          <h3 className="font-heading font-bold text-xl text-white tracking-tight">
            {player.name}
          </h3>
          <p className="text-slate-300 text-sm">{player.club_name}</p>
        </div>
      </div>

      {/* Info section */}
      <div className="p-4 space-y-3">
        <div className="flex items-center gap-4 text-sm text-slate-600">
          <div className="flex items-center gap-1.5">
            <Calendar className="w-4 h-4 text-slate-400" strokeWidth={1.5} />
            <span>{player.age} años</span>
          </div>
          <div className="flex items-center gap-1.5">
            <MapPin className="w-4 h-4 text-slate-400" strokeWidth={1.5} />
            <span>{player.nationality}</span>
          </div>
        </div>

        {player.asking_price && (
          <div className="flex items-center gap-1.5 text-sm">
            <Euro className="w-4 h-4 text-indigo-500" strokeWidth={1.5} />
            <span className="font-semibold text-slate-800">
              {new Intl.NumberFormat('es-ES', {
                style: 'currency',
                currency: 'EUR',
                maximumFractionDigits: 0,
              }).format(player.asking_price)}
            </span>
          </div>
        )}

        <div className="flex items-center justify-between pt-2 border-t border-slate-100">
          <span className="text-xs text-slate-400 uppercase tracking-wider">
            Ver detalles
          </span>
          <ArrowRight className="w-4 h-4 text-indigo-500" strokeWidth={1.5} />
        </div>
      </div>
    </Link>
  );
};

export default PlayerCard;
